<template>
    <div id="intraoralListContainer" class="teeth-ctrls panel-group intraoral-list-ctrl">
        <div id="intraoralListPanel" ref="intraoralListPanel" class="collapse list-group teeth-panel ">
            <div class="teeth-settings">
                <li class="list-group-item setting-item active">Settings</li>
                <li class="list-group-item setting-item">
                    <button type="button" class="btn btn-secondary btn-sm btn-block setting-btn"
                        v-on:click="addTooth">Add Tooth</button>
                </li>
                <li class="list-group-item setting-item active">Elements</li>
            </div>
            <div id="intraoralList" class="teeth-list"></div>
            <div class="teeth-list-bottom">
                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn" v-on:click="close">Close
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import {
    addClick
} from "./IntraoralManager";

export default {
    name: "IntraoralListPanel",
    data() {
        return {
            visibilities: [
                // { text: "Maxilla", key: "maxilla", value: false },
                // { text: "Mandible", key: "mandible", value: false },
            ],
        }
    },
    methods: {
        close: function () {
            console.log("close intraoralListPanel");
            $(`#intraoralListPanel`).removeClass("show");
        },
        addTooth: function () {
            addClick();
        }
    }
}

</script>

<style scoped>
#intraoralListContainer {
    display: none;
}

.teeth-ctrls {
    position: absolute;
    top: 55px;
    left: 9px;
    z-index: 9;
    text-align: right;
    height: calc(100% - 107px);
    width: 0;
    font-family: Montserrat, sans-serif;
    font-size: small;
    background-color: red;
}

.btn {
    font-size: small;
}

.setting-group {
    text-align: right;
    border: 1px solid #ced4da;
    align-items: end;
    border-radius: 0.2rem;
    padding-right: 5px;
}

.setting-ctrl {
    text-align: right;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}


.teeth-panel {
    /* border-radius: 0.25rem;  */
    position: absolute;
    width: 230px;
    /* right: -40px; */
    top: 30px;
    max-height: calc(100% - 40px);
    overflow-y: scroll;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    /* border: solid 1px white; */
}

.teeth-settings {
    width: 100%;
    background: #77a7fd;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}

.setting-item {
    text-align: center;
    padding: .3rem .4rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.setting-btn {
    margin: 2px 0;
    padding: 0;
}

.teeth-list {
    background: white;
    /* #77a7fd; */
    overflow-y: scroll;
    /* max-height: calc(100% - 120px); */
    width: 100%;
    /* calc(100% - 1px); */
    /* margin-left: 1px;
    margin-top: 1px; */
}

.teeth-list-bottom {
    padding-bottom: 8px;
    background-color: white;
    width: 100%;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.apply-btn {
    margin: 0px 5px 0 5px;
    width: calc(100% - 10px);
}

.cancel-btn {
    margin: 8px 5px 0px 5px;
    width: calc(100% - 10px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>